import { Component, OnInit, Inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { SaveForm, Destroyable, untilDestroy, isSomething } from '@tokeet/tv3-platform'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import * as moment from 'moment'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'send-invoice-later-dialog',
  templateUrl: './send-invoice-later-dialog.component.html',
  styleUrls: ['./send-invoice-later-dialog.component.scss'],
})
export class SendInvoiceLaterDialogComponent extends Destroyable implements OnInit {
  form = this.fb.group({
    hours: [null, [Validators.required, Validators.min(1), Validators.max(72)]],
  })

  hourOptions = [3, 6, 12, 24, 48, 36, 72].map((hour) => ({ hour, label: `${hour} Hours` }))

  date: Date

  constructor(
    public dialogRef: MatDialogRef<SendInvoiceLaterDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { invoiceId?: string }
  ) {
    super()
  }

  ngOnInit(): void {
    this.form.valueChanges.pipe(filter(isSomething), untilDestroy(this)).subscribe((hours) => {
      this.date = moment().add(hours, 'hours').toDate()
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const { hours } = this.form.getRawValue()
    const date = moment().add(hours, 'hours').toDate()

    this.dialogRef.close(date)
  }

  close() {
    this.dialogRef.close()
  }
}
